


















































































































































import { Component, Vue } from 'vue-property-decorator';

import DraggableWidget from '@/components/util/DraggableWidget.vue';

import { User } from 'oidc-client';
import { mapGetters } from 'vuex';

import {
  WorkordersApi,
  QueryWorkOrdersRequest,
  WorkorderPagedCollectionApiResponse,
  PerformoSettings
} from 'performo-api';

@Component({
  components: {
    DraggableWidget
  },
  computed: mapGetters({
    currentPropertyId: 'currentPropertyId',
    currentUser: 'currentUser',
    api: 'ordersApi',
    settings: 'settings'
  })
})
export default class WorkerButtonsWidget extends Vue {
  private api!: WorkordersApi;
  private settings!: PerformoSettings;

  private currentPropertyId!: string;
  private currentUser!: User;

  private mineTeamAll!: string;

  private openOrders!: number;
  private priorityOrders!: number;
  private overdueOrders!: number;
  private cmOrders!: number;
  private pmOrders!: number;
  private reqOrders!: number;

  private openOrdersQuery!: QueryWorkOrdersRequest;
  private priorityOrdersQuery!: QueryWorkOrdersRequest;
  private overdueOrdersQuery!: QueryWorkOrdersRequest;
  private cmOrdersQuery!: QueryWorkOrdersRequest;
  private pmOrdersQuery!: QueryWorkOrdersRequest;
  private reqOrdersQuery!: QueryWorkOrdersRequest;

  data() {
    return {
      mineTeamAll: undefined,
      openOrders: undefined,
      priorityOrders: undefined,
      overdueOrders: undefined,
      cmOrders: undefined,
      pmOrders: undefined,
      reqOrders: undefined,
      openOrdersQuery: undefined,
      priorityOrdersQuery: undefined,
      overdueOrdersQuery: undefined,
      cmOrdersQuery: undefined,
      pmOrdersQuery: undefined,
      reqOrdersQuery: undefined
    };
  }

  get mineTeamAllItems() {
    var items = [];

    items.push({ key: 'Mine', value: 'mine' });

    if (this.currentUser.profile.Trades) {
      var workerTrades = this.currentUser.profile.Trades;

      if (Array.isArray(workerTrades)) {
        workerTrades.forEach((element: string) => {
          items.push({ key: element, value: element });
        });
      } else {
        items.push({ key: workerTrades, value: workerTrades });
      }
    }

    // ensure user has view all access before adding it
    if (this.currentUser.profile.candoq.indexOf('View Orders: All') >= 0) {
      items.push({ key: 'All', value: '' });
    }
    return items;
  }

  private storeMineTeamAll(value: string) {
    window.localStorage.setItem('homebuttonsMineTeamAll', value.toString());

    const mineTeamAllSelect =
      document.getElementById('mineTeamAllFilter') ?? false;
    if (mineTeamAllSelect) {
      mineTeamAllSelect.blur();
    }
  }

  get currentOpenOrdersQuery() {
    this.fetchOpenOrders();
    return this.openOrdersQuery;
  }

  private async fetchOpenOrders() {
    this.openOrdersQuery = {
      propertyId: this.currentPropertyId,
      skip: 0,
      take: 1,
      orderStatus: 'Open',
      includeSubStatuses:
        this.settings.openSubStatuses && this.settings.openSubStatuses.length
          ? true
          : undefined
    };

    if (this.mineTeamAll === 'mine') {
      this.openOrdersQuery.assignTo = this.currentUser.profile.WorkerVendor;
    } else if (this.mineTeamAll) {
      this.openOrdersQuery.trade = this.mineTeamAll;
    }

    const pagedOrders: WorkorderPagedCollectionApiResponse =
      await this.api.queryWorkOrders(this.openOrdersQuery);

    if (pagedOrders.pagination?.totalItems) {
      this.openOrders = pagedOrders.pagination.totalItems;
    } else {
      this.openOrders = 0;
    }
  }

  get currentPriorityOrdersQuery() {
    this.fetchPriorityOrders();
    return this.priorityOrdersQuery;
  }

  private async fetchPriorityOrders() {
    this.priorityOrdersQuery = {
      propertyId: this.currentPropertyId,
      skip: 0,
      take: 1,
      orderStatus: 'Open',
      jobPriority: this.settings.workerPriorityQuickFilterValue
        ? this.settings.workerPriorityQuickFilterValue
        : 1
    };

    if (this.mineTeamAll === 'mine') {
      this.priorityOrdersQuery.assignTo = this.currentUser.profile.WorkerVendor;
    } else if (this.mineTeamAll) {
      this.priorityOrdersQuery.trade = this.mineTeamAll;
    }

    const pagedOrders: WorkorderPagedCollectionApiResponse =
      await this.api.queryWorkOrders(this.priorityOrdersQuery);

    if (pagedOrders.pagination?.totalItems) {
      this.priorityOrders = pagedOrders.pagination.totalItems;
    } else {
      this.priorityOrders = 0;
    }
  }

  get currentOverdueOrdersQuery() {
    this.fetchOverdueOrders();
    return this.overdueOrdersQuery;
  }

  private async fetchOverdueOrders() {
    this.overdueOrdersQuery = {
      propertyId: this.currentPropertyId,
      skip: 0,
      take: 1,
      orderStatus: 'Overdue'
    };

    if (this.mineTeamAll === 'mine') {
      this.overdueOrdersQuery.assignTo = this.currentUser.profile.WorkerVendor;
    } else if (this.mineTeamAll) {
      this.overdueOrdersQuery.trade = this.mineTeamAll;
    }

    const pagedOrders: WorkorderPagedCollectionApiResponse =
      await this.api.queryWorkOrders(this.overdueOrdersQuery);

    if (pagedOrders.pagination?.totalItems) {
      this.overdueOrders = pagedOrders.pagination.totalItems;
    } else {
      this.overdueOrders = 0;
    }
  }

  get currentCMOrdersQuery() {
    this.fetchCMOrders();
    return this.cmOrdersQuery;
  }

  private async fetchCMOrders() {
    this.cmOrdersQuery = {
      propertyId: this.currentPropertyId,
      skip: 0,
      take: 1,
      orderStatus: 'Open',
      orderCategory: 'CM'
    };

    if (this.mineTeamAll === 'mine') {
      this.cmOrdersQuery.assignTo = this.currentUser.profile.WorkerVendor;
    } else if (this.mineTeamAll) {
      this.cmOrdersQuery.trade = this.mineTeamAll;
    }

    const pagedOrders: WorkorderPagedCollectionApiResponse =
      await this.api.queryWorkOrders(this.cmOrdersQuery);

    if (pagedOrders.pagination?.totalItems) {
      this.cmOrders = pagedOrders.pagination.totalItems;
    } else {
      this.cmOrders = 0;
    }
  }

  get currentPMOrdersQuery() {
    this.fetchPMOrders();
    return this.pmOrdersQuery;
  }

  private async fetchPMOrders() {
    this.pmOrdersQuery = {
      propertyId: this.currentPropertyId,
      skip: 0,
      take: 1,
      orderStatus: 'Open',
      orderCategory: 'PM'
    };

    if (this.mineTeamAll === 'mine') {
      this.pmOrdersQuery.assignTo = this.currentUser.profile.WorkerVendor;
    } else if (this.mineTeamAll) {
      this.pmOrdersQuery.trade = this.mineTeamAll;
    }

    const pagedOrders: WorkorderPagedCollectionApiResponse =
      await this.api.queryWorkOrders(this.pmOrdersQuery);

    if (pagedOrders.pagination?.totalItems) {
      this.pmOrders = pagedOrders.pagination.totalItems;
    } else {
      this.pmOrders = 0;
    }
  }

  get currentREQOrdersQuery() {
    this.fetchREQOrders();
    return this.reqOrdersQuery;
  }

  private async fetchREQOrders() {
    this.reqOrdersQuery = {
      propertyId: this.currentPropertyId,
      skip: 0,
      take: 1,
      orderStatus: 'Open',
      orderCategory: 'REQ'
    };

    if (this.mineTeamAll === 'mine') {
      this.reqOrdersQuery.assignTo = this.currentUser.profile.WorkerVendor;
    } else if (this.mineTeamAll) {
      this.reqOrdersQuery.trade = this.mineTeamAll;
    }

    const pagedOrders: WorkorderPagedCollectionApiResponse =
      await this.api.queryWorkOrders(this.reqOrdersQuery);

    if (pagedOrders.pagination?.totalItems) {
      this.reqOrders = pagedOrders.pagination.totalItems;
    } else {
      this.reqOrders = 0;
    }
  }

  private doWorkerButtonsWidget() {
    // blank
  }

  created() {
    const mta = window.localStorage.getItem('homebuttonsMineTeamAll');
    var workerTrades = this.currentUser.profile.Trades;
    if (mta && workerTrades && workerTrades.includes(mta)) {
      this.mineTeamAll = mta;
    } else if (
      mta == '' &&
      this.currentUser.profile.candoq.indexOf('View Orders: All') >= 0
    ) {
      // ensure user has view all access before adding it
      this.mineTeamAll = '';
    } else {
      this.mineTeamAll = 'mine';
    }
  }
}
